module.exports = __webpack_public_path__ + "img/tuto_mobile_way_01_06.75c5dc5d.png";